// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_component_wrapper__MYy7U","title":"Video_component_title__LpSSE"};